import { jsx as _jsx } from "react/jsx-runtime";
import { CheckedIcon, Icon } from './IconContainer.styled';
import { forwardRef } from 'react';
import { CheckboxStyled } from './Checkbox.styled';
import { IconContainer } from './IconContainer';
/**
 * **Global Parts** `Checkbox` component.
 *
 * NOTE: You may use both `checked` and `value` props, even though only a `checked` prop is supported by MUI.
 * Using the `value` prop simplifies using the component with form controller.
 */
const Checkbox = forwardRef(({ value, checked, nativeValue, ...props }, ref) => {
    return (_jsx(CheckboxStyled, { disableRipple: true, ...props, 
        // `checked` and `defaultChecked` props must not be used together, that's why `undefined` is assigned to `checked`.
        // `: false` is used here to prevent the following console warning:
        // MUI: A component is changing the uncontrolled checked state of SwitchBase to be controlled.
        // Elements should not switch from uncontrolled to controlled (or vice versa).
        checked: value ?? checked ?? (props.defaultChecked !== undefined ? undefined : false), value: nativeValue, icon: _jsx(IconContainer, { children: _jsx(Icon, {}) }), checkedIcon: _jsx(IconContainer, { children: _jsx(CheckedIcon, { color: props.color }) }), indeterminateIcon: _jsx(IconContainer, { children: _jsx(CheckedIcon, { indeterminate: true, color: props.color }) }), slotProps: { input: { ref } } }));
});
export { Checkbox };
